import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { Me } from '@/types/domain';

export type AuthStatus = 'loading' | 'authenticated' | 'guest';

interface AuthState {
  status: AuthStatus;
  me: Me | null;
}

const initialState: AuthState = { status: 'loading', me: null };

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthenticated(state, action: PayloadAction<Me>) {
      state.status = 'authenticated';
      state.me = action.payload;
    },
    setGuest(state) {
      state.status = 'guest';
      state.me = null;
    },
  },
});

export const { setAuthenticated, setGuest } = authSlice.actions;
export default authSlice.reducer;
